import { useBetSuccessCallback } from '@/hooks/bets/useBetSuccessCallback';
import { DetailedBet } from '@/models/detailed-bet';
import { GenericError } from '@/models/generic-error';
import { BetMoveDto } from '@/services/dto/bet/bet-move-input.dto';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { UseOriginalsMoveProps } from './props';
import { fetchBetMove } from './service';

export function useOriginalsMove(options?: UseOriginalsMoveProps) {
  const { onSuccess, gameId, delay = 0 } = options ?? {};
  const { onSuccess: onSuccessCallback } = useBetSuccessCallback(gameId);

  function handleSuccess(data: DetailedBet, variables: BetMoveDto) {
    if (onSuccess) {
      setTimeout(() => onSuccess(data, variables), delay);
    }

    onSuccessCallback(data);
  }

  const { mutate, isPending, error, data, isError, reset } = useMutation<
    DetailedBet,
    AxiosError<GenericError>,
    BetMoveDto
  >({
    mutationFn: fetchBetMove,
    onSuccess: handleSuccess,
  });

  return {
    moveBet: mutate,
    isPending,
    reset,
    error,
    isError,
    data,
  };
}
